import React, { Component } from 'react'
import { connect } from 'react-redux'

import bindActionCreators from '../../../../lib/utils/bindActionCreators'
import getAccessToken from '../../../../lib/utils/getAccessToken'

import { authAction } from '../../../../actions'

/**
 * @template {object} P
 * @param {React.ComponentType<P>} WrappedComponent
 * @returns {Component<P>}
 */
function withAuth(WrappedComponent) {
  class WithAuth extends Component {
    static displayName = `WithAuth(${WrappedComponent.displayName || WrappedComponent.name})`

    componentDidMount = () => {
      const access_token = getAccessToken()
      this.props.auth(access_token)
    }

    render = () => {
      const { auth, ...otherProps } = this.props
      return <WrappedComponent { ...otherProps } />
    }
  }

  const mapDispatchToProps = bindActionCreators({
    auth: authAction.auth,
  })

  return connect(
    null,
    mapDispatchToProps
  )(WithAuth)
}

export default withAuth



// WEBPACK FOOTER //
// ./src/pages/report/summary-timesheet/hocs/withAuth.js